import React, { forwardRef, useCallback } from 'react';

import { cn } from '@lyearn/style';
import { Box, Checkbox } from '@lyearn/ui';
import useKeyboard from '@/modules/corporate/modules/database/fields/hooks/useKeyboard';
import { CellProps } from '@/modules/corporate/modules/database/types';
import { TableViewActionTypes } from '@/modules/corporate/modules/database/views/TableView/hooks/useTableViewActions/actions';

import { checkboxStyles } from './styles';

export enum CheckboxValue {
  No = 'No',
  Yes = 'Yes',
}

const CheckBox = forwardRef<HTMLDivElement, CellProps>((props, ref) => {
  const { cellData, columnIndex, rowIndex, onAction, column, rowData, viewOnly, className } = props;

  const checked = cellData?.value === CheckboxValue.Yes;

  const onToggle = useCallback(() => {
    if (viewOnly) {
      return;
    }

    const value = checked ? CheckboxValue.No : CheckboxValue.Yes;
    onAction({
      type: TableViewActionTypes.UpdateCellValue,
      payload: { fieldId: column.id, documentId: rowData._id, data: { value } },
    });
  }, [checked, column.id, onAction, rowData._id, viewOnly]);

  const { onKeyDown } = useKeyboard({ onEnterPress: onToggle });

  return (
    <Box
      ref={ref}
      className={cn('h-full w-full cursor-pointer py-8 pe-6 ps-12', className)}
      data-colindex={columnIndex}
      data-rowindex={rowIndex}
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={onKeyDown}>
      <Checkbox checked={checked} className={checkboxStyles} size="medium" tabIndex={-1} />
    </Box>
  );
});

export default CheckBox;
